/*
  w9-pdp.js (2026-10-24): one layout for every product page.
  Loaded by sections/w9-pdp-bar.liquid, a static section rendered at the end of <main> on
  product templates. It only rearranges what the product sections already render, after they
  have run (DOMContentLoaded comes after w9-product-details.js and the install-video docking):

  - Order: the bar goes right under the main product section, the gearing guide under the
    description, and install videos come out of the description into their own row under it.
  - Section bar: one link per section this product has (Overview, Fits N bikes, Gearing guide,
    Install video, Goes with, Reviews (N)), in page order, the one in view underlined. Once the
    buy box's Add to cart scrolls away the bar also shows the price and its own Add to cart,
    which presses the real one (or scrolls back up when a choice is still missing). On phones
    the links are hidden and that price + Add to cart is a bar along the bottom.
  - Buy box: "Fits 15 models from 6 makes" and the first few bikes, read from the list
    w9-product-details built, with the "Will this fit your bike?" check moved in under it;
    Pay in 4 moves under Add to cart; a help card and a returns link join Pickup.
  - Long blocks get an explicit Show all: the fitment list (first 12 bikes; a search or a make
    filter opens it), Goes with (one row of four on desktop), reviews (three, then the whole
    Judge.me widget with its sort and pages).
  - Phones: Product details, Fits these bikes, Install video and Gearing guide fold into
    tap-to-open panels; Product details starts open.
  - Phones under 750px (mobile review, 2026-10-24): the photo comes first and Add to cart fits
    the first screen. The stock badge and SKU move to a line under Add to cart, the photo gets
    swipe and a 1 / N counter, and Ask Warp 9's bubble steps aside while Add to cart is on screen.
  Styles: assets/w9-pdp.css. Nothing here is needed for buying: if a step fails it is skipped.
*/
(function () {
  'use strict';

  var DESK = window.matchMedia('(min-width: 990px)');
  var FIT_SHOWN = 12;
  var REVIEWS_SHOWN = 3;
  var GOES_SHOWN = 4;

  // After every DOMContentLoaded handler (the install videos dock in one). A deferred script
  // runs before DOMContentLoaded, so readyState alone can't tell; `load` covers a late load.
  function ready(fn) {
    if (document.readyState === 'complete') { fn(); return; }
    var done = false;
    function go() { if (!done) { done = true; fn(); } }
    document.addEventListener('DOMContentLoaded', function () { setTimeout(go, 0); });
    window.addEventListener('load', go);
  }

  ready(function () {
    var bar = document.querySelector('[data-w9pb]');
    if (!bar) return;
    var ctx = {
      bar: bar,
      info: document.querySelector('.product-info'),
      pd: document.querySelector('.w9pd[data-w9pd]')
    };
    [order, undockVideo].forEach(function (step) {
      try { step(ctx); } catch (e) { if (window.console) console.warn('w9-pdp', e); }
    });
    if (ctx.pd && ctx.pd.hidden) ctx.pd = null;
    ctx.fit = ctx.pd ? ctx.pd.querySelector('[data-w9pd-fit]') : null;
    if (ctx.fit && ctx.fit.hidden) ctx.fit = null;
    [fitSummary, trustRow, installments, fitList, goesWith, reviews, sectionLinks, stickyBuy, panels,
      phoneStock, phoneChat, phoneGallery].forEach(function (step) {
      try { step(ctx); } catch (e) { if (window.console) console.warn('w9-pdp', e); }
    });
    document.documentElement.classList.add('w9pb-ready');
  });

  /* ---------- helpers ---------- */

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function label(bar, key, n) {
    return (bar.getAttribute('data-label-' + key) || '').replace('[n]', n == null ? '' : n);
  }
  function icon(path, size) {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', size || 16);
    svg.setAttribute('height', size || 16);
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.4');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', path);
    svg.appendChild(p);
    return svg;
  }
  var TICK = 'M20 6 9 17l-5-5';
  var PHONE = 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2';
  var CHEVRON = 'm6 9 6 6 6-6';

  // The child of `root` that holds `node`.
  function childOf(root, node) {
    while (node && node.parentElement !== root) node = node.parentElement;
    return node;
  }
  function visible(e) {
    return !!e && !e.hidden && e.getClientRects().length > 0;
  }
  function headingText(h) {
    if (!h) return '';
    var t = h.firstChild && h.firstChild.nodeType === 3 ? h.firstChild.textContent : h.textContent;
    return t.trim();
  }
  function toggleButton(cls, text, onClick) {
    var b = el('button', 'w9pb-more-btn ' + cls, text);
    b.type = 'button';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', onClick);
    return b;
  }

  /* ---------- order ---------- */

  function sectionOf(node) {
    return node ? node.closest('.shopify-section') : null;
  }
  function placeAfter(node, ref) {
    if (node && ref && ref.parentNode && node !== ref) ref.parentNode.insertBefore(node, ref.nextSibling);
  }

  // Bar under the main product section; gearing guide under the description.
  function order(ctx) {
    var main = sectionOf(ctx.info);
    placeAfter(sectionOf(ctx.bar), main);
    var details = sectionOf(ctx.pd);
    var gear = sectionOf(document.querySelector('.w9g[data-w9g]'));
    if (details && gear) placeAfter(gear, details);
  }

  // w9-install-video docks the videos inside the description; give them their own row instead.
  function undockVideo(ctx) {
    var media = document.querySelector('[data-w9iv-media].is-docked');
    var root = document.querySelector('.w9iv[data-w9iv]');
    if (!media || !root) return;
    var side = media.parentElement;
    root.appendChild(media);
    root.hidden = false;
    media.classList.remove('is-docked');
    var grid = media.querySelector('.w9iv__grid');
    if (grid && media.querySelectorAll('[data-w9iv-id]').length > 1) grid.classList.add('w9iv__grid--multi');
    // The side column held only the videos: give the description the full width again.
    if (ctx.pd && side && side.matches('[data-w9pd-side]') && !side.children.length) {
      side.hidden = true;
      if (ctx.pd.getAttribute('data-fit') === 'media') ctx.pd.setAttribute('data-fit', 'none');
    }
    var details = sectionOf(ctx.pd), videos = sectionOf(root);
    var gear = sectionOf(document.querySelector('.w9g[data-w9g]'));
    placeAfter(videos, gear && details && details.compareDocumentPosition(gear) & Node.DOCUMENT_POSITION_FOLLOWING ? gear : details);
  }

  /* ---------- buy box ---------- */

  function fitSummary(ctx) {
    var info = ctx.info, fit = ctx.fit, bar = ctx.bar;
    var check = document.querySelector('.w9fc');
    if (!info || (!fit && !check)) return;
    // Right above the options (on phones the theme moves the title out of the buy box).
    var options = info.querySelector('.product-variants') || info.querySelector('product-form');
    var before = options ? childOf(info, options) : null;
    if (!before) return;

    var box = el('div', 'w9pb-fit');
    if (fit) {
      if (!fit.id) fit.id = 'w9pb-fitment';
      var count = ((fit.querySelector('[data-w9pd-count]') || {}).textContent || '').trim();
      var head = el('p', 'w9pb-fit__head');
      head.appendChild(icon(TICK, 18));
      head.appendChild(document.createTextNode(count ? 'Fits ' + count.replace(' · ', ' from ') : headingText(fit.querySelector('.w9pd__h'))));
      box.appendChild(head);

      var names = [], total = 0, make = '', lastMake = null;
      Array.prototype.forEach.call(fit.querySelectorAll('[data-w9pd-list] > li'), function (li) {
        if (li.classList.contains('w9pd__make')) { make = li.textContent.trim(); return; }
        total++;
        if (names.length >= 5) return;
        var model = (li.querySelector('.w9pd__model') || li).firstChild;
        model = model ? model.textContent.trim() : '';
        names.push(make && make !== lastMake ? make + ' ' + model : model);
        lastMake = make;
      });
      if (names.length) {
        var p = el('p', 'w9pb-fit__list', names.join(', ') + (total > names.length ? ' and ' + (total - names.length) + ' more. ' : '. '));
        if (total > 1) {
          var a = el('a', 'w9pb-fit__all', label(bar, 'all-bikes', total));
          a.href = '#' + fit.id;
          a.addEventListener('click', function () { openFitList(fit); });
          p.appendChild(a);
        }
        box.appendChild(p);
      }
      var mine = fit.querySelector('[data-w9pd-mybike]');
      if (!check && mine && !mine.hidden && mine.textContent.trim()) {
        var copy = mine.cloneNode(true);
        copy.removeAttribute('data-w9pd-mybike');
        copy.classList.add('w9pb-fit__mine');
        box.appendChild(copy);
      }
    }
    if (check) {
      var sec = check.closest('.shopify-section');
      check.classList.add('w9fc--inbox');
      box.appendChild(check);
      if (sec) sec.classList.add('w9pb-moved');
    }
    before.parentNode.insertBefore(box, before);
  }

  function trustRow(ctx) {
    var info = ctx.info, bar = ctx.bar;
    var sec = info && info.querySelector('.product-info-secondary');
    if (!sec) return;
    var title = bar.getAttribute('data-help-title');
    if (title) {
      var card = el('div', 'w9pb-help');
      card.appendChild(icon(PHONE, 20));
      var t = el('div');
      t.appendChild(el('strong', null, title));
      t.appendChild(el('br'));
      var text = bar.getAttribute('data-help-text') || '';
      var url = bar.getAttribute('data-help-url');
      if (url) { var a = el('a', null, text); a.href = url; t.appendChild(a); }
      else t.appendChild(document.createTextNode(text));
      card.appendChild(t);
      sec.appendChild(card);
    }
    sec.classList.add('w9pb-trust');
    var rurl = bar.getAttribute('data-returns-url'), rlabel = bar.getAttribute('data-returns-label');
    if (rurl && rlabel) {
      var line = el('p', 'w9pb-returns');
      var r = el('a', null, rlabel);
      r.href = rurl;
      line.appendChild(r);
      sec.parentNode.insertBefore(line, sec.nextSibling);
    }
  }

  // Pay in 4 sits under Add to cart instead of between the price and the options.
  function installments(ctx) {
    var info = ctx.info;
    var terms = info && info.querySelector('shopify-payment-terms');
    var form = info && info.querySelector('product-form');
    if (!terms || !form) return;
    var box = childOf(info, terms), after = childOf(info, form);
    if (!box || !after || box === after) return;
    box.classList.add('w9pb-terms');
    after.parentNode.insertBefore(box, after.nextSibling);
  }

  /* ---------- long blocks: Show all ---------- */

  function openFitList(fit) {
    fit.classList.add('w9pb-all');
    var b = fit.querySelector('.w9pb-more-btn');
    if (b) b.hidden = true;
  }

  function fitList(ctx) {
    var fit = ctx.fit;
    if (!fit) return;
    var list = fit.querySelector('[data-w9pd-list]');
    if (!list) return;
    var rows = list.querySelectorAll('.w9pd__row');
    if (rows.length <= FIT_SHOWN + 2) return;
    var seen = 0, header = null, headerKept = false;
    Array.prototype.forEach.call(list.children, function (li) {
      if (li.classList.contains('w9pd__make')) {
        if (header && !headerKept) header.classList.add('w9pb-cut');
        header = li; headerKept = false;
        return;
      }
      seen++;
      if (seen > FIT_SHOWN) li.classList.add('w9pb-cut');
      else headerKept = true;
    });
    if (header && !headerKept) header.classList.add('w9pb-cut');
    var b = toggleButton('w9pb-more-btn--fit', label(ctx.bar, 'all-bikes', rows.length), function () { openFitList(fit); });
    list.parentNode.insertBefore(b, list.nextSibling);
    // A search or a make filter looks through every bike, so it opens the list.
    var search = fit.querySelector('[data-w9pd-search]');
    if (search) search.addEventListener('input', function () { if (search.value.trim()) openFitList(fit); });
    var makes = fit.querySelector('[data-w9pd-makes]');
    if (makes) makes.addEventListener('click', function () { openFitList(fit); });
  }

  function goesWith(ctx) {
    var root = document.querySelector('.w9gw');
    var grid = root && root.querySelector('.w9gw__grid');
    if (!grid) return;
    var cards = Array.prototype.filter.call(grid.children, visible);
    if (cards.length <= GOES_SHOWN) return;
    cards.slice(GOES_SHOWN).forEach(function (li) { li.classList.add('w9pb-cut'); });
    var more = label(ctx.bar, 'see-all', cards.length), fewer = label(ctx.bar, 'fewer');
    var b = toggleButton('w9pb-more-btn--goes', more, function () {
      var on = grid.classList.toggle('w9pb-all');
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      b.textContent = on ? fewer : more;
    });
    (root.querySelector('.w9gw__head') || root).appendChild(b);
    root.classList.add('w9pb-has-more');
  }

  function reviews(ctx) {
    // The main product section carries a Judge.me block of its own; use the reviews section's.
    var w = Array.prototype.filter.call(document.querySelectorAll('.jdgm-rev-widg'), function (x) {
      return !x.closest('.product-info-wrap');
    })[0];
    if (!w) return;
    var sec = w.closest('.shopify-section') || w.parentElement;
    sec.classList.add('w9pb-reviews');
    var n = parseInt(w.getAttribute('data-number-of-reviews') || '0', 10) || 0;
    ctx.reviewCount = n;
    if (!n) { sec.classList.add('is-empty'); return; }
    if (n <= REVIEWS_SHOWN) return;
    sec.classList.add('is-folded');
    var b = toggleButton('w9pb-more-btn--reviews', label(ctx.bar, 'all-reviews', n), function () {
      sec.classList.remove('is-folded');
      b.remove();
    });
    // Under the three reviews (the right-hand column on desktop).
    var body = w.querySelector('.jdgm-rev-widg__body');
    if (body) body.appendChild(b);
    else w.parentNode.insertBefore(b, w.nextSibling);
  }

  /* ---------- section bar ---------- */

  function sectionLinks(ctx) {
    var bar = ctx.bar, nav = bar.querySelector('[data-w9pb-links]');
    if (!nav) return;
    var items = [];
    function add(target, text) {
      if (!target || !text) return;
      if (!target.id) target.id = 'w9pb-' + items.length;
      target.classList.add('w9pb-target');
      items.push({ target: target, text: text });
    }
    if (ctx.pd) add(ctx.pd, label(bar, 'overview'));
    if (ctx.fit) {
      var n = ctx.fit.querySelectorAll('.w9pd__row').length;
      add(ctx.fit, n === 1 ? label(bar, 'fit-one') : label(bar, 'fit', n));
    }
    var gear = document.querySelector('.w9g[data-w9g]');
    if (visible(gear)) add(gear, label(bar, 'gearing'));
    var video = document.querySelector('[data-w9iv-media]');
    if (video) add(video, label(bar, 'video'));
    var goes = document.querySelector('.w9gw');
    if (goes) add(goes, label(bar, 'goes'));
    var rev = document.querySelector('.w9pb-reviews');
    if (rev) add(rev, ctx.reviewCount ? label(bar, 'reviews', ctx.reviewCount) : label(bar, 'reviews', '').replace(/\s*\(\)\s*$/, ''));
    if (items.length < 2) return;
    items.sort(function (a, b) {
      return a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    items.forEach(function (it) {
      var a = el('a', 'w9pb__link', it.text);
      a.href = '#' + it.target.id;
      it.link = a;
      nav.appendChild(a);
    });
    nav.hidden = false;
    bar.classList.add('has-links');

    var current = null, ticking = false;
    function mark() {
      ticking = false;
      var line = bar.getBoundingClientRect().bottom + 24, now = null;
      items.forEach(function (it) { if (it.target.getBoundingClientRect().top <= line) now = it; });
      if (now === current) return;
      if (current) { current.link.classList.remove('is-current'); current.link.removeAttribute('aria-current'); }
      current = now;
      if (current) { current.link.classList.add('is-current'); current.link.setAttribute('aria-current', 'true'); }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(mark); } }, { passive: true });
    mark();
  }

  function priceText(info) {
    var p = info.querySelector('.product-price .price');
    if (!p) return '';
    var sale = p.querySelector('.price-sale .price-item-last');
    var e = sale && visible(sale) ? sale : p.querySelector('.price-regular .price-item-regular') || p.querySelector('.price-item');
    return e ? e.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function stickyBuy(ctx) {
    var bar = ctx.bar, info = ctx.info;
    var buy = bar.querySelector('[data-w9pb-buy]');
    var main = info && info.querySelector('product-form button[name="add"], .product-info .button-add-to-cart');
    if (!buy || !main || !('IntersectionObserver' in window)) return;
    var btn = buy.querySelector('[data-w9pb-atc]'), price = buy.querySelector('[data-w9pb-price]');
    var addLabel = btn.getAttribute('data-label') || btn.textContent;

    function sync() {
      var t = priceText(info);
      if (t) price.textContent = t;
      var off = main.disabled || main.getAttribute('aria-disabled') === 'true';
      var mainText = (main.textContent || '').replace(/\s+/g, ' ').trim();
      btn.textContent = off && mainText ? mainText : addLabel;
      btn.classList.toggle('is-off', off);
    }
    btn.addEventListener('click', function () {
      sync();
      if (main.disabled) {
        (info.closest('.product-page') || info).scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      main.click();
    });

    var root = document.documentElement;
    function show(on) {
      buy.hidden = !on;
      bar.classList.toggle('is-buying', on);
      root.classList.toggle('w9pb-bottom', on && !DESK.matches);
      if (on) { sync(); liftChat(); }
    }
    /* With the phone tab bar on (sections/w9-tabbar), the buy bar takes the bar's place from the first screen. */
    function always() { return !DESK.matches && !!document.querySelector('[data-w9tb]'); }
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      show(always() || (!e.isIntersecting && e.boundingClientRect.top < 0));
    }).observe(main);

    var watch = info.querySelector('.product-price');
    if (watch && 'MutationObserver' in window) {
      new MutationObserver(function () { if (!buy.hidden) sync(); }).observe(watch, { childList: true, subtree: true, characterData: true });
    }
  }

  // Ask Warp 9's launcher sits 20px from the bottom; move it up while the phone buy bar shows.
  function liftChat() {
    var host = document.querySelector('ask-warp9');
    var shadow = host && host.shadowRoot;
    if (!shadow || shadow.querySelector('style[data-w9pb]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-w9pb', '');
    s.textContent = '.launcher{bottom:calc(20px + var(--w9pb-lift, 0px)) !important;transition:bottom .2s}';
    shadow.appendChild(s);
  }

  /* ---------- phones: tap-to-open panels ---------- */

  function panels(ctx) {
    var list = [];
    if (ctx.pd) {
      var about = ctx.pd.querySelector('.w9pd__about');
      if (about && about.textContent.trim()) list.push({ el: about, head: about.querySelector('.w9pd__h'), open: true });
    }
    if (ctx.fit) {
      var n = ctx.fit.querySelectorAll('.w9pd__row').length;
      list.push({ el: ctx.fit, head: ctx.fit.querySelector('.w9pd__fithead'), title: headingText(ctx.fit.querySelector('.w9pd__h')), meta: n ? String(n) : '' });
    }
    var video = document.querySelector('[data-w9iv-media]');
    if (video) {
      var vn = video.querySelectorAll('[data-w9iv-id]').length;
      list.push({ el: video, head: video.querySelector('.w9iv__head'), meta: vn > 1 ? String(vn) : '' });
    }
    var gear = document.querySelector('.w9g[data-w9g]');
    if (visible(gear)) list.push({ el: gear, head: gear.querySelector('h2') });

    list.forEach(function (p) {
      if (!p.head) return;
      var title = p.title || headingText(p.head.matches('h2') ? p.head : p.head.querySelector('h2'));
      if (!title) return;
      var b = el('button', 'w9pb-panel__btn');
      b.type = 'button';
      b.appendChild(el('span', 'w9pb-panel__title', title));
      if (p.meta) b.appendChild(el('span', 'w9pb-panel__meta', p.meta));
      b.appendChild(icon(CHEVRON, 18));
      b.setAttribute('aria-expanded', p.open ? 'true' : 'false');
      b.addEventListener('click', function () {
        var open = p.el.classList.toggle('is-closed') === false;
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      p.head.classList.add('w9pb-panel__orig');
      p.el.classList.add('w9pb-panel');
      if (!p.open) p.el.classList.add('is-closed');
      p.el.insertBefore(b, p.el.firstChild);
    });

    // A link or hash that lands inside a closed panel opens it.
    function openFor(hash) {
      var t = hash && document.getElementById(hash.slice(1));
      var p = t && t.closest('.w9pb-panel.is-closed');
      if (p) {
        p.classList.remove('is-closed');
        var b = p.querySelector('.w9pb-panel__btn');
        if (b) b.setAttribute('aria-expanded', 'true');
      }
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (a) openFor(a.getAttribute('href'));
    });
    openFor(location.hash);
  }

  /* ---------- phones: photo first, Add to cart in the first screen ---------- */

  var SMALL = window.matchMedia('(max-width: 749px)');
  function onChange(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  // On phones the title block sits under the photo (w9-pdp.css), so the stock badge and SKU
  // leave it for a small line under Add to cart. The theme keeps updating them by id.
  function phoneStock(ctx) {
    var form = ctx.info && ctx.info.querySelector('product-form');
    var head = document.querySelector('#product-title-container .product-info-main');
    if (!form || !head) return;
    var homes = [head.querySelector('[id^="ProductAvailability-"]'), head.querySelector('.sku-wrapper')]
      .filter(Boolean)
      .map(function (node) { return { node: node, parent: node.parentNode, next: node.nextSibling }; });
    if (!homes.length) return;
    var line = el('div', 'w9pb-stock');
    function place() {
      if (SMALL.matches) {
        placeAfter(line, form);
        homes.forEach(function (h) { line.appendChild(h.node); });
      } else {
        homes.forEach(function (h) {
          h.parent.insertBefore(h.node, h.next && h.next.parentNode === h.parent ? h.next : null);
        });
        if (line.parentNode) line.parentNode.removeChild(line);
      }
    }
    place();
    onChange(SMALL, place);
  }

  // Ask Warp 9's launcher would sit on the buy box's Add to cart, which is now in the first screen
  // on phones, so it steps aside while that button is on screen (as it does for the cart drawer).
  // The widget draws itself later, so this also runs on load and after 3 seconds.
  function phoneChat(ctx) {
    var main = ctx.info && ctx.info.querySelector('product-form button[name="add"], .button-add-to-cart');
    if (!main || !('IntersectionObserver' in window)) return;
    var away = false;
    function apply() {
      var host = document.querySelector('ask-warp9');
      var shadow = host && host.shadowRoot;
      if (!shadow) return;
      if (!shadow.querySelector('style[data-w9pb-away]')) {
        var s = document.createElement('style');
        s.setAttribute('data-w9pb-away', '');
        s.textContent = ':host(.w9pb-away) .launcher{opacity:0;visibility:hidden;transform:translateY(12px)}';
        shadow.appendChild(s);
      }
      host.classList.toggle('w9pb-away', away && SMALL.matches);
    }
    new IntersectionObserver(function (entries) {
      away = entries[entries.length - 1].isIntersecting;
      apply();
    }).observe(main);
    window.addEventListener('load', apply);
    setTimeout(apply, 3000);
    onChange(SMALL, apply);
  }

  // Photo: swipe left or right to step through the photos (the theme's arrows do the work), and a
  // 1 / N counter with dots shows where you are. On phones w9-pdp.css hides the arrows until
  // focused, the progress bar and the thumbnails.
  function phoneGallery(ctx) {
    var g = document.querySelector('#MainContent media-gallery');
    var wrap = g && g.querySelector('.product-media-main-wrapper');
    var prev = g && g.querySelector('.media-gallery-prev');
    var next = g && g.querySelector('.media-gallery-next');
    if (!wrap || !prev || !next) return;
    var mains = Array.prototype.slice.call(wrap.querySelectorAll('.product-media-main'));
    if (mains.length < 2) return;
    var bar = el('div', 'w9pb-gal');
    bar.setAttribute('aria-hidden', 'true');
    var dots = null;
    if (mains.length <= 10) {
      dots = el('span', 'w9pb-gal__dots');
      mains.forEach(function () { dots.appendChild(el('i')); });
      bar.appendChild(dots);
    }
    var count = el('span', 'w9pb-gal__n');
    bar.appendChild(count);
    wrap.appendChild(bar);
    g.classList.add('w9pb-swipe');

    function sync() {
      var at = 0;
      mains.forEach(function (m, i) { if (m.classList.contains('is-active')) at = i; });
      count.textContent = (at + 1) + ' / ' + mains.length;
      if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === at); });
    }
    sync();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      mains.forEach(function (m) { mo.observe(m, { attributes: true, attributeFilter: ['class'] }); });
    }

    var x0 = null, y0 = 0;
    wrap.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (x0 === null || !SMALL.matches) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) (dx < 0 ? next : prev).click();
    }, { passive: true });
  }
})();
